import { render, staticRenderFns } from "./DataTableBody.vue?vue&type=template&id=6b15a789&scoped=true&"
import script from "./DataTableBody.vue?vue&type=script&lang=js&"
export * from "./DataTableBody.vue?vue&type=script&lang=js&"
import style0 from "./DataTableBody.vue?vue&type=style&index=0&id=6b15a789&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b15a789",
  null
  
)

export default component.exports